import { db } from "./firebase";

export function getSavingVariables() {
  return db.collection("ARPvariables").doc("ToolsWhatIsSavingsVariables");
}

export function getSavingVariablesFil() {
  return db.collection("ARPvariables").doc("ToolsWhatIsSavingsVariables-Fil");
}
